















// vendor
import { defineComponent, computed } from "@vue/composition-api";
import * as AppModal from "@/AppModal";
import { useTranslate } from "@lang";

export default defineComponent({
	props:{
		value:{
			type:String,
			default:"name",
		},
	},
	components:{
	},
	setup(props, context){
		
		const selectedLabel = computed(() => {
			return sortOptions.value.find(o => o.value === props.value)?.text || "-";
		});
		
		const sortOptions = computed(() => {
			return [
				{ value: "name", text: translate("label.name") },
				{ value: "lastModified", text: translate("label.modified") },
			]
		});

		const { translate } = useTranslate();

		const openMenu = (e:Event) => {
			AppModal.context(e, sortOptions.value.map(o => {
				return {
					name:o.text,
					icon:props.value === o.value ? "mdi.check" : "",
					fn(){
						context.emit("input", o.value);
					}
				}
			}))
		};

		return {
			sortOptions,
			openMenu,
			selectedLabel,
		};
	}
});

